// extracted by mini-css-extract-plugin
export var cardIcon = "_5q-4";
export var checkboxCard = "_5q-0";
export var checkboxCardSelected = "_5q-3";
export var disabled = "_5q-1";
export var outerBorder = "_5q-2";
export var spacerMedium = "_5q-7";
export var spacerSmall = "_5q-6";
export var spacerXsmall = "_5q-5";